<template>
    <div style="cursor: pointer;" @click="$emit('clickedItem', item_id)">
        <i class="fas" :class="getItemState" style="width: 1.1rem;"></i>
        {{text}}
    </div>
</template>

<script>
export default {
    props:{
        enabled:{
            required: true,
            type: Boolean,
        },
        item_id:{
            required: true,
        },
        text:{
            required: true,
        }
    },
    data:() => ({}),
    computed:{
        getItemState(){
            if(this.enabled){
                return 'fa-check text-success';
            }
            else{
                return 'fa-times text-muted';
            }
        }
    },
    methods:{},
    mounted(){},
}
</script>

<style>

</style>